export const linear = (timeFraction: number) => timeFraction;
